export function capitalize (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function truncate (value, maxCount) {
  var n = 30
  if (maxCount) {
    n = maxCount
  }
  return (value.length > n) ? value.substr(0, n - 1) + '...' : value
}

export function convertDeliveryType (value) {
  switch (value) {
    case 'hot_pickup':
      return 'Pickup'
    case 'hot_delivery':
      return 'Hot Delivery'
    case 'frozen_delivery':
      return 'Frozen Delivery'
    default:
      return value
  }
}

export function convertPaymentType (value) {
  switch (value) {
    case 'bank_transfer':
      return 'Bank Transfer'
    case 'cash':
      return 'Cash'
    case 'credit_card':
      return 'Credit Card'
    default:
      return value
  }
}

export function convertStatus (value) {
  switch (value) {
    case 'pending':
      return 'Pending'
    case 'processing':
      return 'Processing'
    case 'completed':
      return 'Completed'
    case 'cancelled':
      return 'Cancelled'
    default:
      return value
  }
}



// WEBPACK FOOTER //
// ./src/util/filters.js